<template>
    <section v-if="Object.keys(componentType).length > 0">
        <transition-group name="modal">
            <div id="brand" class="modal-mask" key="brand">
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody">
                            <div class="modalContent">
                                <h1 class="uppercase productShadeTitle">{{ componentType.name }}</h1>
                                <form enctype="multipart/form-data" class="form_campaing" action="">
                                    <table>
                                        <tr>
                                            <td><label class="label">Nom</label></td>
                                            <td><input class="input" type="text" v-model="componentType.name" /></td>
                                        </tr>
                                        <tr>
                                            <td><label class="label">Nom EN</label></td>
                                            <td v-if="componentType.terms.hasOwnProperty('name')">
                                                <input class="input" type="text" v-model="componentType.terms.name['en']['value']" />
                                            </td>
                                            <td v-else=""><input class="input" type="text" v-model="nameEN" /></td>
                                        </tr>
                                        <tr>
                                            <td><label class="label">Nom FR</label></td>
                                            <td v-if="componentType.terms.hasOwnProperty('name')">
                                                <input class="input" type="text" v-model="componentType.terms.name['fr']['value']" />
                                            </td>
                                            <td v-else=""><input class="input" type="text" v-model="nameFR" /></td>
                                        </tr>
                                    </table>
                                </form>
                            </div>
                            <br />
                            <br />
                            <div class="flexContainer boutonSaveDelete">
                                <button class="btn block pointer uppercase save" @click="saveEditBrand();">{{ $t("zone.save") }}</button>
                                <button class="btn block pointer uppercase save" @click="closeModal();">{{ $t("common.cancel") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import httpService from "../service";

export default {
    data() {
        return {
            componentType: {},
            nameEN: "",
            nameFR: ""
        };
    },
    watch: {},
    mounted() {},
    methods: {
        closeModal() {
            this.$emit("hideEditComponent");
        },
        saveEditBrand() {
            let obj = {
                name: this.componentType.name,
                active: 1,
                translations: [
                    {
                        field: "name",
                        locale: "en",
                        id: this.componentType.terms.name["en"]["id"],
                        content: this.nameEN
                    },
                    {
                        field: "name",
                        locale: "fr",
                        id: this.componentType.terms.name["fr"]["id"],
                        content: this.nameFR
                    }
                ]
            };
            httpService.put("/admin/components/types/" + this.componentType.id, JSON.stringify(obj)).then(response => {
                location.reload();
            });
        }
    },
    computed: {
        ...mapGetters({
            getComponentType: "items/getComponentType"
        })
    },
    created() {
        httpService.get("/admin/components/types/" + this.getComponentType).then(response => {
            this.componentType = response;
        });
    }
};
</script>

<style lang="scss" scoped>
.logoRem3rch {
}

.selectCampaign {
    border: none;
    border-bottom: 1px solid #343434;
    width: 100%;
    font-size: 14px;
    font-family: Roboto;
}

.zones {
    overflow-y: scroll;
    height: 100px;
}

.boutonSaveDelete {
    margin-left: 290px;
    .save {
        margin-right: 12px;
    }
}

.help {
    margin-top: 20px;
    margin-left: 262px;
}

#spinnerLoader {
    left: 0;
    top: 50%;
    width: 100%;
    .loader {
        margin: auto;
    }
}

.teinteCert {
    padding-left: 60px;
}

.zoneChecked {
    margin-left: 2px;
}

.campaignTable {
    width: 40%;
    padding-bottom: 12px;
}

.productShadeTitle {
    font-family: "Oswald", Sans-Serif;
}

.inputShades {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
}

.labelInput {
    margin-top: 2px;
    font-family: Roboto;
    font-weight: bold;
    font-size: 1.17em;
    padding-left: 20px;
    padding-right: 10px;
}

.labelInputShades {
    margin-top: 2px;
    font-family: Roboto;
    font-size: 1.17em;
    padding-right: 10px;
}

/* height firefox modal */
._modalWrapper_ {
    height: auto;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 77px;
        right: 300px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            background: #fff;
            width: 900px;
            height: auto;
            border-radius: 4px;
            padding: 15px;
            margin: auto;
            .modalContent {
                h2 {
                    font-size: 1.6rem;
                }
                p {
                    font-size: 1.4rem;
                    margin: 30px 0;
                }
                #favoriteName {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid #343434;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// EditComponentType.vue?2b118ec6